<span class="tooltip-icon" (mouseenter)="showTooltip=true" (mouseleave)="showTooltip=false">{{ label }}</span>
<div class="tooltip" *ngIf="showTooltip">
    <p>{{ text }}</p>
</div>
